/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1FeedbackTypeList200,
  GetApiV1FeedbackTypeList401,
  GetApiV1FeedbackTypeList500,
  GetApiV1FeedbackTypeListQueryResponse,
} from "../../types/feedbackRegistroController/GetApiV1FeedbackTypeList.ts";
import { dropDownListViewModelSchema } from "../dropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1FeedbackTypeList200Schema = z.array(
  z.lazy(() => dropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1FeedbackTypeList200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1FeedbackTypeList401Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackTypeList401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1FeedbackTypeList500Schema =
  z.any() as unknown as ToZod<GetApiV1FeedbackTypeList500>;

export const getApiV1FeedbackTypeListQueryResponseSchema = z.lazy(
  () => getApiV1FeedbackTypeList200Schema,
) as unknown as ToZod<GetApiV1FeedbackTypeListQueryResponse>;
